import MessagesTable from '@/features/dashboard/messages/components/MessagesTable.tsx';

const MessagesPage = () => {
  return <MessagesTable />;
};

export default MessagesPage;
